import { render, staticRenderFns } from "./CartSection.vue?vue&type=template&id=449bbd98&scoped=true&"
import script from "./CartSection.vue?vue&type=script&lang=js&"
export * from "./CartSection.vue?vue&type=script&lang=js&"
import style0 from "./CartSection.vue?vue&type=style&index=0&id=449bbd98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bbd98",
  null
  
)

export default component.exports